import { v1UserRepository, V1User } from '@webapp/platform/iam'

interface SecondaryCategoryAccessFormDefaults {
  userOptions: V1User[]
}

export const getSecondaryCategoryAccessFormDefaults =
  async (): Promise<SecondaryCategoryAccessFormDefaults> => {
    const result = await v1UserRepository.listActiveUsers({ limit: 9999 })
    const userOptions = result.data.map(
      (constructor) => new V1User(constructor)
    )
    return { userOptions }
  }
